<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Microsoft Yahei", "PingFang SC", Avenir, "Segoe UI", "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif", "WenQuanYi Micro Hei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}

ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

body {
  margin: 0px;
  padding: 0px;
  background: rgba(83, 1, 7, 1);
}

a {
  text-decoration: none
}</style>



// WEBPACK FOOTER //
// src/App.vue